import React, { useRef } from 'react';
import styles from './BlurredTextBox.module.css';

const BlurredTextBox = ({ text , setShowNotification, setNotificationMessage }) => {
  const buttonRef = useRef(null);

  const handleCopyText = () => {
    const textToCopy = document.getElementById('inputBox').innerText;

    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        console.log('Text copied to clipboard');
        setNotificationMessage("Successfully copied to clipboard!"); // Set custom message
      })
      .catch((error) => {
        console.error('Failed to copy text:', error);
        setNotificationMessage("Failed to copy text. Try again!"); // Error message
      });

    setShowNotification(true);
  };

  return (
    <div className={`${styles.textBox} `} style={{padding: "10px", gap: '20px'}}>
      <div className={`row justify-content-center ` } style={{gap: '20px'}}>
        <div className={`col-md-2 d-flex flex-column align-items-center justify-content-center`}>
          <p> Widget URL: </p>
        </div>
        <div className={`col-md-6 d-flex flex-column align-items-center justify-content-center`} style={{padding: "10px"}}>
          <div className={styles.blurredTextbox}>
            <div className={styles.overlayText}><p onClick={handleCopyText}>Click To Copy</p></div>
            <div id="inputBox" className={styles.blurredText}>{text}</div>
          </div>
        </div>
        <div className={`col-md-2 d-flex flex-column align-items-center justify-content-center`}>
          <button ref={buttonRef} onClick={handleCopyText}>
            Copy text
          </button>
        </div>

      </div>
    </div>
  );
};

export default BlurredTextBox;
